import { gql } from "@apollo/client";

export const GET_PAGE_PERMISSION = gql`
  query QPermisoPagina ($idUsuario: Int!, $path: String!) {
    permisoPagina
    (
        idUsuario: $idUsuario,
        path: $path
    ) 
    {
        success,
        error,
        valorEsperado 
    }
}`;